import type { Clue, PuzzleId, PuzzleInstance, PuzzleType } from '../types.ts';
import { camerasModule } from './cameras.ts';
import { corridorModule } from './corridor.ts';
import { escapeModule } from './escape.ts';
import { laserModule } from './laser.ts';
import { lockModule } from './lock.ts';
import { panelModule } from './panel.ts';
import { passwordModule } from './password.ts';
import { safeModule } from './safe.ts';
import type { GenContext, PuzzleModule } from './types.ts';
import { vaultModule } from './vault.ts';

export const PUZZLES: Record<PuzzleType, PuzzleModule> = {
  lock: lockModule,
  safe: safeModule,
  panel: panelModule,
  cameras: camerasModule,
  laser: laserModule,
  password: passwordModule,
  corridor: corridorModule,
  escape: escapeModule,
  vault: vaultModule,
};

export const PUZZLE_TYPES = Object.keys(PUZZLES) as PuzzleType[];

/** Builds a puzzle instance from a module's generator. */
export function createPuzzle(id: PuzzleId, type: PuzzleType, ctx: GenContext): PuzzleInstance {
  const gen = PUZZLES[type].generate(ctx);
  const clues: Clue[] = gen.clues;
  return {
    id,
    type,
    room: ctx.room,
    level: ctx.level,
    solved: false,
    solvedAtMs: null,
    params: gen.params,
    state: gen.state,
    clues,
    solvers: gen.solvers,
  };
}
